import React, { useContext } from 'react';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';

interface AddToCartButtonProps {
  handleSubmit: () => void;
  isDisabled: boolean;
  isLoading: boolean;
}

function AddToCartButton({ handleSubmit, isDisabled, isLoading }: AddToCartButtonProps): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  return (
    <button
      type="button"
      onClick={handleSubmit}
      className="button button--primary add-to-cart-button"
      disabled={isDisabled || isLoading}
    >
      <span className={`loader ${isLoading ? '' : 'hide'}`} />
      <span
        className={`button__text ${isLoading ? 'hide' : ''}`}
        dangerouslySetInnerHTML={{
          __html: formattedMessage({ id: 'basket.add.to.basket', fallback: 'Add <span>to Bag</span>' })
        }}
      />
    </button>
  );
}

export default AddToCartButton;
